var Tiers = {
	//////////////////////////////////////////////////////////////////////////////////////////////
	////// CAUTION - THESE REQUIREMENTS ARE IN OTHER CODEBASES, SO BE CAREFUL CHANGING THEM //////
	//////////////////////////////////////////////////////////////////////////////////////////////
	// returns the requirements to advance from the given tier to the next tier up
	// TODO: consumables as requirements for tiers 3+
	REQUIREMENTS: {
		"0": {
			patches: { "body": 1, "head": 1 },
			perks: { "houses": 1 }
		},

		"1": {
			patches: { "body": 1, "head": 1, "hand": 2 },
			perks: { "total": 2 }
		},
		"2": {
			patches: { "body": 1, "head": 1, "hand": 2, "feet": 1, "face": 1 },
			perks: { "total": 2 }
		},
		"3": {
			patches: { "body": 1, "head": 1, "hand": 2, "feet": 1, "face": 1, "beak": 1 },
			perks: { "total": 1 },
			furnitures: {"wall_items": 1}
		},
		"4": {
			patches: { "body": 2, "head": 1, "feet": 1, "face": 1},
			furnitures: {"wall_items": 1, "bookshelves": 1, "floor_items": 1}
		},
		"5": {
			patches: { "head": 1},
			furnitures: {"wall_items": 1, "sofas": 1, "bookshelves": 1, "floor_items": 1}
		}
	},
	//////////////////////////////////////////////////////////////////////////////////////////////
	////// END CAUTION ///////////////////////////////////////////////////////////////////////////
	//////////////////////////////////////////////////////////////////////////////////////////////

	TYPES: {
		"0": {
			name: "Egg",
			description: "",
			color: "#42af14"
		},
		"1": {
			name: "Hatchling",
			description: "",
			color: "#e46e36"
		},
		"2": {
			name: "Nestling",
			description: "",
			color: "#60179e"
		},
		"3": {
			name: "Fledgling",
			description: "",
			color: "#dbb926"
		},
		"4": {
			name: "Grown",
			description: "",
			color: "#0082c8"
		},
		"5": {
			name: "Master",
			description: "",
			color: "#a1011e"
		},
		"6": {
			name: "Wise",
			description: "",
			color: "#555555"
		}
	},
	SCALERS: {
		"addressed_feedback": {
			"qunit": 0.05,
			"factor_x": true
		},

		"take_photo": {
			"qunit": 0.5,
			"factor_x": true
		}
	},
	getTierMultiplier(tier) {
		switch (tier) {
			case 0:
				return 1.0;
			case 1:
				return 2.0;
			case 2:
				return 3.0;
			case 3:
				return 4.0;
			case 4:
				return 5.0;
			case 5:
				return 6.0;
			default:
				return 6.0;
		}
	},

	getData(tierKey) {
		return Tiers.TYPES[tierKey];
	},

	getName: function(tierKey) {
		var tier = Tiers.getData(tierKey);
		if (tier) { return tier.name; }
	},

	getDescription: function(tierKey) {
		var tier = Tiers.getData(tierKey);
		if (tier) { return tier.description; }
	},

	getIcon: function(tierKey) {
		var tier = Tiers.getData(tierKey);
		if (tier) {
			return dynamicRequire("tiers/wing-" + tierKey + ".png");
		}		
	},

	getColor: function(tierKey) {
		var tier = Tiers.getData(tierKey);
		if (tier) { return tier.color }
	},

	getRequirements(tier) {
		// default to tier 3 requirements for unrecognized tier values
		return Tiers.REQUIREMENTS[tier.toString()] || Tiers.REQUIREMENTS["3"];
	},

	isSupportedTier(tier) {
		return tier.toString() in Tiers.REQUIREMENTS;
	},

	getQunitXValue(item_type, tier) {
		if (item_type in Tiers.SCALERS) {
			var item = Tiers.SCALERS[item_type];
			var value = Tiers.QUNIT * item.qunit;
			if (item.factor_x) {
				value *= Tiers.getTierMultiplier(tier);
			} 

			return value;
		} else {
			return 0;
		}
	},

}

Tiers.QUNIT = 200;
module.exports = Tiers;



// WEBPACK FOOTER //
// ./modules/lib/games/Tiers.js